import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { StaticSvgIconProp, SvgIconProp } from '../../models/dynamic.model';
import { SvgIconGenerationService } from '../../services/svg-icon-generation.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
})
export class SvgIconComponent implements OnChanges {
  @Input() list!: SvgIconProp[];
  @Input() isStaticSvg!: boolean;
  @Input() iconName!: string;
  @Input() isFrom!: string;
  @Input() condition!: string;
  @Output() staticIconClicked = new EventEmitter<StaticSvgIconProp>();

  public staticList!: StaticSvgIconProp;

  constructor(private readonly svgIconGenServices: SvgIconGenerationService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.staticList = this.svgIconGenServices.generateStaticIcon(
      changes['iconName'].currentValue,
      this.isFrom
    );
  }

  public staticIconClick(staticList: StaticSvgIconProp) {
    this.staticIconClicked.emit(staticList);
  }
}
